import { IClaimType } from "../contracts/IClaimType";

export const claims: IClaimType = {
  ActivatedDate: "activated_date",
  Address: "address",
  Audience: "aud",
  ClientId: "client_id",
  ClientName: "client_name",
  CommunityId: "community-id",
  CommunityName: "community-name",
  Email: "email",
  FirstName: "first_name",
  Groups: "groups",
  Initials: "initials",
  LandingPage: "landing_page",
  LastName: "last_name",
  MiddleName: "middle_name",
  Name: "name",
  Nickname: "nickname",
  OrganizationId: "organization_id",
  OrganizationName: "organization_name",
  Permission: "permission",
  Picture: "picture",
  PhoneNumber: "phone_number",
  PostalCode: "postal_code",
  Profile: "profile",
  Region: "region",
  Role: "role",
  RoleName: "role-name",
  Scope: "scope",
  Subject: "sub",
  UserId: "user_id",
  Username: "username",
};

export const permissions: IClaimType = {
  SystemAdmin: "system-admin",
  SystemFull: "system-full",
  ManageUser: "manage-user",
  ManageLookup: "manage-lookup",
  ManageCommunity: "manage-community",
  ManageCommunitySafety: "manage-commuity-safety",
  ManagePlan: "manage-plan",
  ManageSubscription: "manage-subscription",
  ManageQuestionnaire: "manage-questionnaire",
  ManageResource: "manage-resource",
  ManageQuicklinks: "manage-quicklinks",
  ManageSociallinks: "manage-sociallinks",
  ManageRssfeeds: "manage-rssfeeds",
  ManageNewsfeeds: "manage-newsfeeds",
  ManageEvents: "manage-events",
  ManageBackgrounds: "manage-backgrounds",
  ManagePushNotifications: "manage-push-notifications",
  ManageCommunityDevelopment: "manage-community-development",
  ViewReports: "view-reports",
  ViewSystemSettingSection: "view-system-setting-section",
  ViewAccountSettingSection: "view-account-setting-section",
  ViewAdminSettingSection: "view-admin-setting-section",
  ViewQuestionnaireSettingSection: "view-questionnaire-setting-section",
  ViewPopHubSettingSection: "view-pophub-setting-section",
  ManageServiceRequest: "manage-service-request",
};

export const roles: IClaimType = {
  SystemAdmin: "system-admin",
  CommunityAdmin: "community-admin",
};

export const userType: IClaimType = {
  SystemUser: "system-user",
  ApplicationUser: "application-user",
};
